<script lang="ts">
    import type {HierarchyTree, RecordHierarchyTreeNode, HierarchyTreeNode, UUID} from 'typings/portaro.be.types';
    import KpGenericHierarchyTreesView from 'shared/components/kp-generic-hierarchy-trees-view/KpGenericHierarchyTreesView.svelte';
    import {fade} from 'svelte/transition';
    import {getLocalization} from 'core/svelte-context/context';

    export let hierarchyTrees: HierarchyTree<UUID, RecordHierarchyTreeNode>[];

    const localize = getLocalization();

    function recastToRecordTreeNode(node: HierarchyTreeNode<UUID | number>): RecordHierarchyTreeNode {
        return node as RecordHierarchyTreeNode;
    }
</script>

{#if hierarchyTrees.length > 0 && hierarchyTrees[0].nodes.length > 1}
    <div class="record-hierarchy-panel" transition:fade|global={{duration:200}}>
        <KpGenericHierarchyTreesView hierarchyTrees={hierarchyTrees} let:node>
            <!-- if the next line is red then IDEA/Svelte plugin still do not support new features (ignore it) -->
            {@const recordTreeNode = recastToRecordTreeNode(node)}
            {#if recordTreeNode.current}
                <strong>{recordTreeNode.text}</strong>
            {:else if recordTreeNode.see}
                {localize(/* @kp-localization commons.viz */ 'commons.viz')}: {recordTreeNode.text}
            {:else }
                {#if recordTreeNode.seeAlso}
                    {localize(/* @kp-localization commons.vizTez */ 'commons.vizTez')}:
                {/if}
                <a href="/records/{recordTreeNode.id}">{recordTreeNode.text}</a>
            {/if}
        </KpGenericHierarchyTreesView>
    </div>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .record-hierarchy-panel {
        padding: @panel-heading-padding;
        border-radius: @border-radius-base;
        border: 1px solid #d3d3d3;
        -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
    }
</style>